import * as React from 'react';
import ChevronRightSmallOutlined from './chevron-right-small-outlined';
import ChevronRightSmallFilled from './chevron-right-small-filled';
import type { IconCombinedProps } from './types';
const ChevronRightSmallCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ChevronRightSmallFilled ref={ref} {...rest} />;
  }
  return <ChevronRightSmallOutlined ref={ref} {...rest} />;
});
export default ChevronRightSmallCombined;